import * as ActionTypes from "../../actions/actionTypes";


const initialState= {
  isSuccessful: false,
  payload: {}
}

const coinPrice = (state = initialState, action) => {
  switch (action.type) {

    case ActionTypes.FETCH_COINS_FAIL:
      return {
        ...state,
        payload: {},
        isSuccessful: false,
      };

    case ActionTypes.FETCH_COINS_PRICE:
      return {
        ...state,
        payload: action.payload,
        isSuccessful: true,
      };

    default:
      return state;
  }
};

export default coinPrice;